import cookie from "../components/cookie";
import requests from "../components/requests";
import scrollTop from "../components/scrollTop";
import jCaptcha from "../components/captcha";
import navigation from "../components/navigation";
import share from "../components/share";
import toggle from "../components/toggle";
import utm from "../components/utm";
import languageSelection from "../components/languageSelection";

export default {
  init() {
    // JavaScript to be fired on all pages
  },
  finalize() {
    const scrollTopButton = document.querySelector('.scroll-btn');
    const commentForm = document.querySelector('#commentform');
    const languageSelect = document.querySelector('.language-selection');
    cookie();
    requests();
    navigation();
    share();
    toggle();
    utm();

    // call change language module
    if (languageSelect !== null) {
      languageSelection(languageSelect);
    }

    if (scrollTopButton !== null) {
      scrollTop(scrollTopButton);
    }

    function ValidateEmail(emailInput)
    {
      if (/^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(emailInput))
      {
        return true;
      }
      return false;
    }

    if (commentForm) {
      const form = document.getElementById('commentform');
      const captchaInput = document.querySelector('.jCaptcha');
      const commentField = document.querySelector('.comment-form-comment #comment');
      const myCaptcha = new jCaptcha({
        el: '.jCaptcha',
        canvas: {
          class: 'jCaptchaCanvas',
        },
        callback: (response, $captchaInputElement) => {
          if (response == 'success') {
            let emailInput = document.querySelector('.comment-form-email') && document.querySelector('.comment-form-email #email').value;
            if(commentField.value.length > 3 && ValidateEmail(emailInput)){
              HTMLFormElement.prototype.submit.call(form);
            } else {
              commentField.classList.add('is-error');
            }
          }
          if (response == 'error') {
            $captchaInputElement.classList.add('is-error')
          }
        }
      });
      captchaInput.addEventListener('focus', function () {
        captchaInput.classList.remove('is-error')
      });
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        myCaptcha.validate();
      });


    }
  },

};
